import React from 'react'
import Header from '../containers/header'
import Footer from '../containers/footer/Footer'

class RebrandPage extends React.Component {
  constructor (props) {
    super(props)
  }

  render () {
    return (
      <div style={{ height: '100vh' }}>
        <Header />
        <div
          id="rebrand"
          className="section container-fluid rebrand-layout pageTitle"
        >
          <div className="rebrand-header">
            <h1 className="rebrand-header-mobile">
              We're now <span>NicheSolv</span>
            </h1>
            <img
              src="/images/rebranded-cover.png"
              alt="rebrandedImage"
              className="rebrand-image"
            />
            <div className="rebrand-header-text">
              <h1>
                We&apos;re now <span>NicheSolv</span>
              </h1>
              <p className="rebrand-header-title">
                Yes, we are! We are now a Private Limited Company!
              </p>
              <p className="rebrand-header-title">
                However - due to name clashes - we&apos;ve chosen an alternate name-
                NicheSolv (निश साल्व or ನಿಶ್ ಸಾಲ್ವ್)
              </p>
            </div>
          </div>
          <div className="rebrand-content">
            <div className="rebrand-meaning-container">
              <h1>
                <span>Meaning</span> of NicheSolv ?
              </h1>
              <p className="rebrand-meaning-title">
                We love solving those hard-to-solve tech problems -
                so the new name better describes who we
                are!
              </p>
              <p className="rebrand-meaning-title">
                In Sanskrit - "निशाति" - means to "meditate deeply". So, you can say we
                meditate deeply (when needed only!) and solve your tech problems!
              </p>
            </div>
            <img
              src="/images/meaningOfNichesolv.jpg"
              alt="meaningOfNichesolv"
              className="meaning-of-nichesolv-image"
            />
            <div className="rebrand-header-mobile">
              <p className="rebrand-meaning-mobile">
                We love solving those hard-to-solve tech problems -
                so the new name better describes who we
                are!
              </p>
              <p className="rebrand-meaning-mobile">
                In Sanskrit - "निशाति" - means to "meditate deeply". So, you can say we
                meditate deeply (when needed only!) and solve your tech problems!
              </p>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    )
  }
}

export default RebrandPage



// WEBPACK FOOTER //
// /home/reetika/Desktop/nichesolvweb/website/nswebsite/src/containers/rebrand.js